export default {
  questionOrder: null,
  answers: []
}
